'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_StorePage$Dialog$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.a7l = null;
  this.a7k = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_pages_StorePage$Dialog$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "editStore");
  this.a7l = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
  var name$1 = (((this.al !== null) && this.al.l()) ? this.al.k() : "editItem");
  this.a7k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$1);
}
export { $c_Lmealorama_pages_StorePage$Dialog$ as $c_Lmealorama_pages_StorePage$Dialog$ };
$p = $c_Lmealorama_pages_StorePage$Dialog$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_pages_StorePage$Dialog$;
/** @constructor */
function $h_Lmealorama_pages_StorePage$Dialog$() {
}
export { $h_Lmealorama_pages_StorePage$Dialog$ as $h_Lmealorama_pages_StorePage$Dialog$ };
$h_Lmealorama_pages_StorePage$Dialog$.prototype = $p;
var $d_Lmealorama_pages_StorePage$Dialog$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_StorePage$Dialog$, "mealorama.pages.StorePage$Dialog$", ({
  Ly: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_pages_StorePage$Dialog$ as $d_Lmealorama_pages_StorePage$Dialog$ };
var $n_Lmealorama_pages_StorePage$Dialog$;
function $m_Lmealorama_pages_StorePage$Dialog$() {
  if ((!$n_Lmealorama_pages_StorePage$Dialog$)) {
    $n_Lmealorama_pages_StorePage$Dialog$ = new $c_Lmealorama_pages_StorePage$Dialog$();
  }
  return $n_Lmealorama_pages_StorePage$Dialog$;
}
export { $m_Lmealorama_pages_StorePage$Dialog$ as $m_Lmealorama_pages_StorePage$Dialog$ };
//# sourceMappingURL=mealorama.pages.-Store-Page$-Dialog$.js.map
